import { Link } from "react-router-dom";
import CSS from "./static/css/HomeLinkLogo.module.css";

const HomeLinkLogo = () => {
    return (
        <Link
            to="/tabs/home"
            className={CSS.l_HomeLinkLogo_main}
            aria-label="MyStudio 홈"
        >
            <span className={CSS.l_HomeLinkLogo__mark} aria-hidden="true">
                <svg viewBox="0 0 48 48" focusable="false">
                    <path d="M16.5 12.5h5.4l1.8-3h8.2l1.8 3h5.8A5.5 5.5 0 0 1 45 18v18.5A5.5 5.5 0 0 1 39.5 42h-31A5.5 5.5 0 0 1 3 36.5V18a5.5 5.5 0 0 1 5.5-5.5h3.1l1.5-3.5h4.8l-1.4 3.5Z" />
                    <path d="M24 33.7s-9-5.4-9-11.1c0-2.7 2.1-4.8 4.8-4.8 1.7 0 3.1.8 4.2 2.1 1.1-1.3 2.5-2.1 4.2-2.1 2.7 0 4.8 2.1 4.8 4.8 0 5.7-9 11.1-9 11.1Z" />
                </svg>
            </span>
            <span className={CSS.l_HomeLinkLogo__word}>
                <span>My</span>
                <strong>Studio</strong>
            </span>
        </Link>
    );
};

export default HomeLinkLogo;
